import { create } from 'zustand';

/**
 * Maps entity IDs (UUIDs) to human-readable labels for breadcrumbs.
 *
 * Detail pages call `setEntityLabel(id, label)` when data loads.
 * The Breadcrumb component reads from this store to replace UUIDs with names.
 */
interface BreadcrumbState {
  labels: Record<string, string>;
  setEntityLabel: (id: string, label: string) => void;
  clearEntityLabel: (id: string) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  labels: {},

  setEntityLabel: (id, label) =>
    set((s) => ({
      labels: { ...s.labels, [id]: label },
    })),

  clearEntityLabel: (id) =>
    set((s) => {
      const next = { ...s.labels };
      delete next[id];
      return { labels: next };
    }),
}));
